var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoicesIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 50,
    viewBox: "0 0 46 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.328918 0.616608V46.2877H28.4342V42.7745H3.84208V4.12977H21.4079V14.6692H31.9474V18.1824H35.4605V12.21L34.9336 11.6831L24.3941 1.14358L23.8671 0.616608H0.328918ZM24.921 6.58898L29.4882 11.1561H24.921V6.58898ZM7.35524 18.1824V21.6956H28.4342V18.1824H7.35524ZM37.2171 21.6956V25.2087C34.2309 25.7357 31.9474 28.1949 31.9474 31.3568C31.9474 34.8699 34.5822 37.5048 38.0954 37.5048H39.852C41.2572 37.5048 42.4868 38.7344 42.4868 40.1397C42.4868 41.5449 41.2572 42.7745 39.852 42.7745H33.7039V46.2877H37.2171V49.8009H40.7303V46.2877C43.7164 45.7607 46 43.3015 46 40.1397C46 36.6265 43.3651 33.9916 39.852 33.9916H38.0954C36.6901 33.9916 35.4605 32.762 35.4605 31.3568C35.4605 29.9515 36.6901 28.7219 38.0954 28.7219H44.2434V25.2087H40.7303V21.6956H37.2171ZM7.35524 26.9653V30.4785H19.6513V26.9653H7.35524ZM23.1645 26.9653V30.4785H28.4342V26.9653H23.1645ZM7.35524 33.9916V37.5048H19.6513V33.9916H7.35524ZM23.1645 33.9916V37.5048H28.4342V33.9916H23.1645Z",
    fill: "#1B2E6B",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicesIcon1);
export default __webpack_public_path__ + "static/media/invoices-icon1.0c7ed67ec81335cd8a20cec24fc7adcf.svg";
export { ForwardRef as ReactComponent };